import { RegisterCard } from "../components/RegisterCard";
import { TopAdminNav } from "../layouts/TopAdminNav";
import { useState, useEffect } from "react";
import BackButton from "../components/backButton";
import Swal from "sweetalert2";
import { formatTime } from "../utilities/importantFns";
import { defaultUrl } from "../features/actions";
import { StaffDataType } from "../types/interfaces";
import { makeFetchRequest, makePostRequest } from "../utilities/common";
import StudentListInput from "../staff_pages/staff_components/staff_student_data/StudentListInput";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import CustomModal from "../components/CustomModal/CustomModal";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";

export const AuthurizePickup = () => {
  const date = new Date();
  const dateString = formatTime(date, true);
  const [staffData, setStaffData] = useState<StaffDataType[]>([]);
  const [refresh, setRefresh] = useState(false);
  const [currentChild, setCurrentChild] = useState<any>();
  const [openModal2, setOpenModal2] = useState(false);

  /** FILTERINGS */
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState<any[]>([]);

  async function fetchData() {
    const pickUps = await makeFetchRequest(`${defaultUrl}/getAuthorizePickup`);
    const result =
      pickUps &&
      pickUps.map((staff: any) => {
        return {
          ...staff,
          profile_picture: (
            <LazyLoadImage
              className="w-full h-full object-cover"
              src={staff.picker_image}
              effect="blur"
              wrapperProps={{
                style: {
                  transitionDelay: "0.2s",
                  display: "block",
                  width: "100%",
                  height: "100%",
                },
              }}
              alt=""
            />
          ),
        };
      });
    setStaffData(result && result.reverse());
  }

  useEffect(() => {
    const filtered =
      staffData &&
      staffData.filter((data) => {
        if (!searchTerm.length) {
          return data;
        }
        const token = data.picker_token;
        return token.toLowerCase().includes(searchTerm.toLowerCase());
      });
    setFilteredData(filtered);
  }, [searchTerm, staffData]);

  useEffect(() => {
    const searchBar = document.getElementById("searchStaffInput");
    searchBar?.focus();
    fetchData();
  }, [refresh]);

  const triggerAuthorizeDialog = (item: any) => {
    Swal.fire({
      title: `Confirm pickup with code: <span class="text-[#0096D1]">${item.picker_token}</span>`,
      html: `You are confirming <b> ${item.student?.firstname || ""} ${
        item.student?.surname || ""
      } ${item.student?.othername || ""}</b> to be picked`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#012063",
      cancelButtonColor: "#f43f5e",
      confirmButtonText: "Yes, confirm it!",
    }).then((result) => {
      if (result.isConfirmed) {
        confirmAuthorize(item.id, item.student?.id);
      }
    });
  };

  const confirmAuthorize = async (id: any, user_id: any) => {
    await makePostRequest(`${defaultUrl}/picked/${id}`, {}, "Pickup Confirmed");
    setRefresh(!refresh);
    handleLogout(user_id);
  };

  const handleLogout = async (user_id: any) => {
    const logOutData = {
      type: "logout",
      student_id: [user_id],
      time: dateString,
      image: ["null"],
      video: "null",
      description: "picked",
    };

    await makePostRequest(
      `${defaultUrl}/activity_feed/create`,
      logOutData,
      "Student Logged out",
    );
  };

  return (
    <div className="relative w-full">
      <div className="w-full flex items-center mb-4">
        <BackButton />
        <TopAdminNav name="Jane Doe" title="Authorized Pick Up" />
      </div>

      <div className="flex w-full">
        <div className="block w-full h-[87vh] overflow-auto register-scroll">
          <div className="flex px-1 mb-5">
            <div className="w-full">
              <RegisterCard
                title="Secure Pickup Verification Control"
                details="Authorize Student checkouts via unique encrypted token parameters"
              />
            </div>
          </div>

          <div className="bg-white rounded-xl border border-slate-100 shadow-sm p-5 max-w-[98%] mx-auto">
            <div className="mb-4">
              <StudentListInput
                searchType="by Token"
                onChange={(e: any) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="w-full overflow-x-auto rounded-xl border border-slate-50 mt-4">
              <table className="w-full border-collapse text-left table-fixed min-w-[750px]">
                <thead>
                  <tr className="bg-[#F4F7FE] border-b border-slate-100 text-[11px] font-bold tracking-wider text-[#012063] uppercase">
                    <th className="py-4 px-5 w-[30%]">Student Identity</th>
                    <th className="py-4 px-4 w-[25%]">Emergency Contact</th>
                    <th className="py-4 px-4 w-[20%] text-center">
                      Authorization Portrait
                    </th>
                    <th className="py-4 px-4 w-[15%] text-center">
                      Encrypted Token
                    </th>
                    <th className="py-4 px-4 w-[15%] text-center">
                      Execution Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-50">
                  {staffData && staffData.length > 0 ? (
                    filteredData.map((item: any, index: number) => (
                      <tr
                        key={index}
                        className="group bg-white hover:bg-slate-50/40 transition-colors duration-150 text-[13px] text-slate-600 font-medium"
                      >
                        <td className="py-4 px-5 font-bold text-slate-800 tracking-tight capitalize">
                          {item.student?.firstname} {item.student?.surname}
                        </td>
                        <td className="py-4 px-4 text-slate-700 font-semibold">
                          {item.emergency_contact?.contact_name}
                        </td>
                        <td className="py-2 px-4">
                          <div className="flex justify-center">
                            <div className="h-14 w-14 rounded-full overflow-hidden border border-slate-200 shadow-sm bg-slate-50 group-hover:border-[#0096D1] transition-colors">
                              {item?.profile_picture}
                            </div>
                          </div>
                        </td>
                        <td className="py-4 px-4 text-center font-mono text-sm font-black text-slate-900 tracking-wide">
                          {item.picker_token}
                        </td>
                        <td className="py-4 px-4 text-center whitespace-nowrap align-middle">
                          <Menu
                            menuButton={
                              <MenuButton className="inline-flex items-center justify-center gap-1 rounded-xl px-4 py-1.5 bg-slate-50 border border-slate-200 text-slate-700 text-xs font-bold shadow-sm hover:bg-slate-100 active:scale-95 transition-all">
                                Actions
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  strokeWidth={2.5}
                                  stroke="currentColor"
                                  className="w-2.5 h-2.5 text-slate-400"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                                  />
                                </svg>
                              </MenuButton>
                            }
                            transition
                            align="end"
                            offsetY={4}
                            menuClassName="bg-white border border-slate-100 rounded-xl shadow-xl p-1.5 min-w-[155px]"
                          >
                            <MenuItem
                              onClick={() => triggerAuthorizeDialog(item)}
                              className="flex items-center gap-2 px-3 py-2 text-xs font-semibold text-emerald-600 rounded-lg cursor-pointer hover:bg-emerald-50 transition-colors"
                            >
                              Verify Code & Pick
                            </MenuItem>
                            <MenuItem
                              onClick={() => {
                                setCurrentChild(item);
                                setOpenModal2(true);
                              }}
                              className="flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-600 rounded-lg cursor-pointer hover:bg-slate-50 transition-colors"
                            >
                              Inspect Details
                            </MenuItem>
                          </Menu>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={5}
                        className="py-12 text-center text-slate-400 font-medium text-sm"
                      >
                        No active secure verification parameters discovered...
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Complete Verification Inspection Modal Overlay Sheet */}
      {openModal2 && (
        <CustomModal
          title="Secure Verification Inspection Profile"
          hideModal={() => setOpenModal2(false)}
        >
          <div className="space-y-6 text-left p-2 max-w-2xl">
            {/* Student Cluster */}
            <div className="pb-4 border-b border-slate-100">
              <h4 className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-3">
                Target Student
              </h4>
              <div className="flex items-center gap-4">
                <img
                  src={currentChild?.student?.profile_picture}
                  alt="Student"
                  className="w-16 h-16 rounded-2xl object-cover border border-slate-100 shadow-sm"
                />
                <div className="space-y-0.5">
                  <p className="text-sm font-bold text-slate-800">
                    {currentChild?.student?.firstname}{" "}
                    {currentChild?.student?.surname}
                  </p>
                  <p className="text-xs font-medium text-slate-400">
                    {currentChild?.student?.email || "No email registration"}
                  </p>
                </div>
              </div>
            </div>

            {/* Picker Cluster */}
            <div className="pb-4 border-b border-slate-100">
              <h4 className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-3">
                Assigned Transit Custodian
              </h4>
              <div className="flex items-center gap-4">
                <img
                  src={currentChild?.picker_image}
                  alt="Picker"
                  className="w-16 h-16 rounded-2xl object-cover border border-slate-100 shadow-sm"
                />
                <div className="space-y-1">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-bold text-slate-400">
                      Verification Token:
                    </span>
                    <span className="px-2 py-0.5 rounded font-mono text-xs font-bold bg-slate-100 text-slate-700 tracking-wide border border-slate-200/60">
                      {currentChild?.picker_token}
                    </span>
                  </div>
                  <p className="text-xs text-slate-600 font-medium leading-relaxed">
                    <span className="font-bold text-slate-400">
                      Reason Matrix:
                    </span>{" "}
                    {currentChild?.reason || "Standard daily check-out track"}
                  </p>
                  <div className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-bold mt-1 bg-amber-50 border border-amber-200 text-amber-700">
                    <span className="w-1 h-1 rounded-full bg-amber-500" />
                    Pending Checkout Verification
                  </div>
                </div>
              </div>
            </div>

            {/* Emergency Contact Cluster */}
            {currentChild?.emergency_contact && (
              <div>
                <h4 className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-3">
                  Authorized Contact Origin Link
                </h4>
                <div className="flex items-center gap-4">
                  <img
                    src={currentChild?.emergency_contact?.photo}
                    alt="Contact Link"
                    className="w-16 h-16 rounded-2xl object-cover border border-slate-100 shadow-sm"
                  />
                  <div className="space-y-0.5">
                    <p className="text-sm font-bold text-slate-800">
                      {currentChild?.emergency_contact?.contact_name}
                    </p>
                    <p className="text-xs font-medium text-slate-500">
                      Line:{" "}
                      <span className="text-slate-700 font-semibold">
                        {currentChild?.emergency_contact?.phone}
                      </span>
                    </p>
                    <p className="text-xs font-bold text-[#0096D1]">
                      Relationship:{" "}
                      {currentChild?.emergency_contact?.relationship}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default AuthurizePickup;
